import { render } from "./UpdateExtraService.vue?vue&type=template&id=180e5c90"
import script from "./UpdateExtraService.vue?vue&type=script&lang=js"
export * from "./UpdateExtraService.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__